"use client";

import { Button } from "@/components/ui/button";
import { useBuildVersionCheck } from "@/utils/hooks/useBuildVersionCheck";
import { useState } from "react";
import { FiRefreshCw, FiX } from "react-icons/fi";

// Aviso discreto y descartable -- a propósito no fuerza el reload. A
// diferencia de la recuperación automática en app/global-error.tsx (que
// reacciona quando el chunk YA falló), esto avisa con anticipación mientras
// la pestaña sigue funcionando con el build viejo, y deja que el usuario
// decida cuándo recargar para no perderle algo que esté completando (un
// formulario de candidato, un presupuesto, etc.).
export function UpdateAvailableBanner() {
  const hasNewVersion = useBuildVersionCheck();
  const [dismissed, setDismissed] = useState(false);

  if (!hasNewVersion || dismissed) return null;

  return (
    // pointer-events-auto: mientras hay un Dialog/Sheet modal de Radix abierto,
    // el <body> queda con pointer-events:none y el banner (fuera del árbol del
    // modal) heredaba eso, quedando visible pero sin poder clickearse.
    // stopPropagation en pointerdown/focus evita que Radix lo interprete como
    // una interacción "afuera" y cierre el modal (perdiendo lo que el usuario
    // esté completando).
    <div
      className="pointer-events-auto fixed bottom-4 left-1/2 z-[100] w-[calc(100%-2rem)] max-w-md -translate-x-1/2 rounded-lg border border-gray-200 bg-white p-4 shadow-lg dark:border-gray-700 dark:bg-gray-800"
      onPointerDown={(e) => e.stopPropagation()}
      onFocus={(e) => e.stopPropagation()}
    >
      <div className="flex items-start gap-3">
        <div className="flex-1">
          <p className="text-sm font-medium text-gray-900 dark:text-white">
            Hay una nueva versión disponible
          </p>
          <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
            Actualiza cuando puedas para evitar errores de carga.
          </p>
        </div>
        <button
          onClick={() => setDismissed(true)}
          className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-300"
          aria-label="Cerrar aviso"
        >
          <FiX size={16} />
        </button>
      </div>
      <div className="mt-3 flex justify-end gap-2">
        <Button variant="ghost" size="sm" onClick={() => setDismissed(true)}>
          Ahora no
        </Button>
        <Button
          size="sm"
          onClick={() => window.location.reload()}
          className="gap-1.5"
        >
          <FiRefreshCw size={14} />
          Actualizar
        </Button>
      </div>
    </div>
  );
}
